module.exports = __webpack_public_path__ + "img/icon-headset-gear.7a08ad28.png";